import { DocumentTemplateService } from "../services/document/document-template.service";
import { store } from "../store/store";

export const SET_DOCUMENT_TEMPLATES = "SET_DOCUMENT_TEMPLATES";

export const fetchDocumentTemplates = async () => {
  try {
    const res = await DocumentTemplateService.getList();
    store.dispatch(setDocumentTemplates(res));
  } catch (err) {
    console.log(err);
  }
};

export const setDocumentTemplates = (data: any) => {
  return {
    type: SET_DOCUMENT_TEMPLATES,
    data,
  };
};
